<script lang="ts">
    function reload() {
        window.location.reload()
    }
</script>

<div class="bno-container bno-container--centered">
    <div class="bno-container__content">
        <p>Rezervační formulář se nepodařilo načíst.<br/>Zkuste to, prosím, později.</p>
        <button class="bno-button bno-button--primary" on:click={reload}>
            Obnovit stránku
        </button>
    </div>
</div>
